import { ProjectConfiguration } from "@stories/pages/Contractor/ProjectConfiguration/ProjectConfiguration";

export const ProjectView = () => {
  return <ProjectConfiguration />;
};
